import React from 'react'

import Breadcrumbs from '@mui/material/Breadcrumbs'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import { H2, H3, Text } from '@mxenabled/mxui'

import { useGlobalCopyStore } from '../../../common'

interface HeaderProps {
  buttonCopy: string
  hasRequestButton?: boolean
  onNavigateToList: () => void
  onRequestSupport: () => void
  title: string
  topicTitle: string
}

export const Header: React.FC<HeaderProps> = ({
  buttonCopy,
  hasRequestButton,
  onNavigateToList,
  onRequestSupport,
  title,
  topicTitle,
}) => {
  const { help: helpCopy } = useGlobalCopyStore()
  return (
    <React.Fragment>
      <Grid container={true} sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <H3 color="text.primary">{title}</H3>
          <Breadcrumbs
            separator={
              <Text bold={true} color="grey.600" sx={{ fontWeight: 700 }} variant="body2">
                /
              </Text>
            }
          >
            <Text
              bold={true}
              color="primary.main"
              onClick={onNavigateToList}
              sx={{ cursor: 'pointer', fontWeight: 700 }}
              variant="body2"
            >
              {helpCopy.list_title}
            </Text>
            <Text bold={true} color="text.secondary" sx={{ fontWeight: 700 }} variant="body2">
              {topicTitle}
            </Text>
          </Breadcrumbs>
        </Grid>
        {hasRequestButton && (
          <Grid
            size={{ xs: 12, sm: 6 }}
            sx={{
              display: 'flex',
              justifyContent: { sm: 'flex-end' },
              mt: { xs: 24, sm: 0 },
            }}
          >
            <Button aria-label={buttonCopy} onClick={onRequestSupport} variant="contained">
              {buttonCopy}
            </Button>
          </Grid>
        )}
      </Grid>
      <H2 color="text.primary" sx={{ mt: 24, whiteSpace: { sm: 'nowrap' } }}>
        {topicTitle}
      </H2>
    </React.Fragment>
  )
}
